<script lang="ts">
    import Vue from "vue";
    import { Component } from 'vue-facing-decorator';
    import { FormDefDependenciesReadModel } from '@Alternatives/Forms/Domain/readmodels';
    import FormDependenciesList from "@Alternatives/Forms/Components/FormDependenciesList.vue";
    import { FormDeleterDialogViewModel } from "@Alternatives/Forms/Components/FormDeleterDialog";

    @Component({
        components: { FormDependenciesList },
        props: {
            viewModel: { type: Object, required: true }            
        }
    })
    export default class FormDeleterDialog extends Vue
    {
        get vm(): FormDeleterDialogViewModel { return this.$props.viewModel as FormDeleterDialogViewModel; }

        get opened(): boolean { return this.vm?.opened ?? false; }
        get initialized(): boolean { return this.vm.initialized; }
        get name(): string { return this.vm.name; }
        get deps(): FormDefDependenciesReadModel | null { return this.vm.deps; }
        get hasDependants(): boolean | null { return this.deps?.HasDependants ?? null; }
        get dependantsCount(): number | null { return this.deps?.Count ?? null; }
        get canDelete(): boolean { return this.initialized && this.hasDependants === false; }

        handleDelete()
        {
            this.$emit('delete-form', this.vm.id);
        }

        close()
        {
            this.vm.close();
        }
    }
</script>

<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-lg modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header" :class="{'bg-danger': canDelete}">
                        <h5 class="modal-title">Delete form</h5>
                        <button type="button" class="close" @click="close">&times;</button>
                    </div>
                    <div class="modal-body">
                        <h4 v-if="!initialized">
                            <i class="fa fa-spinner fa-spin"></i> Checking dependencies...
                        </h4>
                        <div v-if="initialized">
                            <div v-if="canDelete">
                                <h4>Are you sure you want to delete this form?</h4>
                                <p>You are about to delete '<strong>{{name}}</strong>'. This can't be undone.</p>
                            </div>
                            <div v-if="!canDelete">
                                <div class="alert alert-danger text-dark" role="alert">
                                    <h5 class="alert-heading">Cannot delete this form</h5>
                                    <p>
                                        The form '<strong>{{name}}</strong>' is used in <strong>{{dependantsCount}}</strong> places.
                                        To delete this form, first remove it from where it is used.
                                    </p>
                                </div>
                                <FormDependenciesList :readModel="deps" />
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button v-if="canDelete" type="button" class="btn btn-danger" @click="handleDelete">Delete</button>
                        <button type="button" class="btn btn-outline-secondary" @click="close">Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
    .modal-header.bg-danger .modal-title,
    .modal-header.bg-danger .close {
        color: white;
    }
</style>